import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { PricingService } from "shared/cubiq-services";

import * as _d3 from "@bfx/d3";

import { StrategyLayoutConfigData } from "./StrategyLayoutConfigData";
import { StrategyLayoutData } from "./StrategyLayoutData";
import { StrategyData } from "./StrategyData";
import { LinkedStrategyData } from "./LinkedStrategyData";
import { OEApiService } from "app/order-entry/services/oe-api.service";
import { OEStrategyRenderService } from "app/order-entry/services/basic/oe-strategy-render.service";
import { LoggerService } from "@bfx/logger";
import { NativeDesktopSupport } from "app/bfx-native-desktop/native-desktop-support";
const logger = LoggerService.for(__dirname);

export const DEFAULT_CONFIG_DATA: StrategyLayoutConfigData = {
  orderWidth: 150,
  orderHeight: 28,
  linkWidth: 75,
  linkHeight: 75,
  linkPadding: 4,
  // set to zero for calculated width/height
  width: 0,
  height: 0,
  scrollbarPaddingSize: 6,
  selectable: true,
  selectableManaged: true,
  removable: true,
};

export const splitLabelTextAtIndex = (str: string) => {
  let numRegex = /\d/;
  let foundNumber = str.match(numRegex);
  return foundNumber != null && foundNumber.index != null ? foundNumber.index : str.length;
};

export class BfxOrderEntryStrategyLayoutPlugin {
  private _configData: StrategyLayoutConfigData = DEFAULT_CONFIG_DATA;

  private _svg = null;

  private _selectedNode = null;
  private _selectedId = null;

  public constructor(
    private _pricingService: PricingService | null = null,
    private _oeActions: OEStrategyRenderService | null = null, // TODO: consider having _oeModel generate model directly //	private _oeModel: BfxOrderEntryModelService | null = null,
  ) {}

  public reset() {
    this._svg = null;
    this._selectedNode = null;
    this._selectedId = null;
  }
  // not in use
  /* 	public scale(data: StrategyLayoutData) {
		// useful when data is provided off thread

		let config = this._configData;

		data.width = (config.orderWidth * (data.maxX + 1)) + (config.linkWidth * data.maxX) +
			this._configData.scrollbarPaddingSize;
		data.height = (config.orderHeight * (data.maxY + 1)) + (config.linkHeight * data.maxY) +
			this._configData.scrollbarPaddingSize;

		data.nodes.forEach(function (d, key) {
			d.iX = d.x;
			d.iY = d.y;
			d.x = (config.orderWidth * d.x) + (config.linkWidth * d.x);
			d.y = (config.orderHeight * d.y) + (config.linkHeight * d.y);
		});

		return data;
	}
 */
  public scale2(data: StrategyLayoutData) {
    let config = this._configData;

    data.nodes.forEach(function (d, key) {
      d.iX = d.x;
      d.iY = d.y;
      d.x = config.orderWidth * d.x + config.linkWidth * d.x;
      d.y = config.orderHeight * d.y + config.linkHeight * d.y;
    });

    let maxX = 0;
    let maxY = 0;
    data.nodes.forEach((d, key) => {
      maxX = d.x > maxX ? d.x : maxX;
      maxY = d.y > maxY ? d.y : maxY;
    });

    data.width = maxX + config.orderWidth + 30;
    data.height = maxY + config.orderHeight + 30;
    return data;
  }

  /* public data(rootOrder: CubiqTS.OrderDataImpl): StrategyLayoutData {
		let orderMap = new Map();             // key:x#y# value:d
		let childLinks = [];         // y ... y + 1
		let siblingLinks = [];       // x ... x + 1
		let visitorPaths = [];  // set
		let width = 0;
		let height = 0;
		let maxX = 0;
		let maxY = 0;
		let pricingService = this._pricingService;


		function adaptOrderDataImpl(this: void, order: CubiqTS.OrderDataImpl, d: StrategyData) {
			d.label = '';
			d.id = order.orderId.toString();

			if (CubiqTS.RequestOrderType.CALL === order.requestedOrderType) {
				// A call will preempt clientIntent
				d.label += 'CALL ';
			} else if (CubiqTS.OrderIntent.BUY === order.clientIntent) {
				d.label += 'B ';
			} else if (CubiqTS.OrderIntent.SELL === order.clientIntent) {
				d.label += 'S ';
			} else {
				logger.out.warn('Failed to parse client intent');
			}

			if (order.requestedOrderType == Object(order.requestedOrderType)) {
				if (order.requestedOrderType === CubiqTS.RequestOrderType.TP) {
					d.label += "TP";
				} else if (order.requestedOrderType === CubiqTS.RequestOrderType.SL_ATRATE ||
					order.requestedOrderType === CubiqTS.RequestOrderType.SL_BID ||
					order.requestedOrderType === CubiqTS.RequestOrderType.SL_ASK) {
					d.label += "SL";
				} else if (order.requestedOrderType === CubiqTS.RequestOrderType.TSL ||
					order.requestedOrderType === CubiqTS.RequestOrderType.TSL_BID ||
					order.requestedOrderType === CubiqTS.RequestOrderType.TSL_ASK) {
					d.label += "TSL";
				}
			}

			if (order.requestRt !== null || order.requestRt !== undefined) {
				d.label += ' ' + pricingService.getOrderRequestRt(order) + ' ';
			}



			if (Array.isArray(order.childRelationships)) {
				d.childRelationshipTypes = order.childRelationships.map((relationship: CubiqTS.Relationship) => {
					return relationship.relationshipType;
				});
			}

			if (order.siblingRelationship === Object(order.siblingRelationship)) {
				d.siblingRelationshipType = order.siblingRelationship.relationshipType;
			}
		}

		function adaptOrderRequestDataImpl(this: void, orderRequest: CubiqTS.OrderRequestDataImpl, d: StrategyData) {
			d.label = '';
			d.id = orderRequest.orderId.toString();

			if (CubiqTS.RequestOrderType.CALL === orderRequest.requestOrderType) {
				// A call will preempt clientIntent
				d.label += 'CALL ';
			} else if (CubiqTS.OrderIntent.BUY === orderRequest.clientIntent) {
				d.label += 'B ';
			} else if (CubiqTS.OrderIntent.SELL === orderRequest.clientIntent) {
				d.label += 'S ';
			} else {
				logger.out.warn('Failed to parse client intent');
			}

			if (orderRequest.requestRate !== null || orderRequest.requestRate !== undefined) {
				// TODO string? already formated?
				d.label += '@ ' + orderRequest.requestRate + ' ';
			}

			if (orderRequest.requestOrderType == Object(orderRequest.requestOrderType)) {
				if (orderRequest.requestOrderType === CubiqTS.RequestOrderType.TP) {
					d.label += "TP";
				} else if (orderRequest.requestOrderType === CubiqTS.RequestOrderType.SL_ATRATE ||
					orderRequest.requestOrderType === CubiqTS.RequestOrderType.SL_BID ||
					orderRequest.requestOrderType === CubiqTS.RequestOrderType.SL_ASK) {
					d.label += "SL";
				} else if (orderRequest.requestOrderType === CubiqTS.RequestOrderType.TSL ||
					orderRequest.requestOrderType === CubiqTS.RequestOrderType.TSL_BID ||
					orderRequest.requestOrderType === CubiqTS.RequestOrderType.TSL_ASK) {
					d.label += "TSL";
				}
			}

			if (Array.isArray(orderRequest.childRelationships)) {
				d.childRelationshipTypes = orderRequest.childRelationships.map((relationship: CubiqTS.LinkedRelationshipImpl) => {
					return relationship.relationshipType;
				});
			}

			if (orderRequest.sibling === Object(orderRequest.sibling)) {
				d.siblingRelationshipType = orderRequest.sibling.relationshipType;
			}
		}

		function handleOrder(this: void, order: CubiqTS.OrderDataImpl | CubiqTS.LinkedOrderRequestImpl | CubiqTS.OrderRequestDataImpl, d: StrategyData, x, y, oX, oY, childIndex?) {
			if (order instanceof CubiqTS.OrderDataImpl) {
				adaptOrderDataImpl(order, d);
			} else if (order instanceof CubiqTS.LinkedOrderRequestImpl) {
				adaptOrderRequestDataImpl(order.rootOrder, d);
			} else if (order instanceof CubiqTS.OrderRequestDataImpl) {
				adaptOrderRequestDataImpl(order, d);
			}

			d.x = x;
			d.y = y;

			if (oX === undefined || oX === null) {
				oX = -1;
			}

			if (oY === undefined || oY === null) {
				oY = -1;
			}

			// track for translation
			maxX = Math.max(maxX, x);
			maxY = Math.max(maxY, y);

			// check for link to sibling
			if (childIndex === undefined) {
				let siblingLink =
					handleBacklink('x' + oX + 'y' + oY, d, 'SIBLING');
				if (siblingLink !== null) {
					siblingLinks.push(siblingLink);
				}
			} else {
				// check for link to parent
				let childLink =
					handleBacklink('x' + oX + 'y' + oY, d, 'CHILD', childIndex);
				if (childLink !== null) {
					childLinks.push(childLink);
				}
			}

			// track for d3 data() & scaling (can't scale yet!)
			if (orderMap.has('x' + x + 'y' + y)) {
				throw new Error('Node Collsion');
			}

			orderMap.set('x' + x + 'y' + y, d);
		};

		function handleBacklink(this: void, key, d: StrategyData, type, index?) {
			let source: StrategyData = orderMap.get(key);
			if (source !== undefined && source !== null) {
				d.visitorPath = source.visitorPath.slice();

				let expiryIndex =
					source.visitorPath[source.visitorPath.length - 1]
						.expiryIndex;

				if (index === undefined) {
					d.visitorPath.push({
						type: type,
						// pathType - refactor or add isSibling/isChild to enum?
						orderRelationshipType: source.siblingRelationshipType,
						expiryIndex: expiryIndex,
						sourceId: source.id,
						rootId: d.visitorPath[0].rootId,
						targetId: d.id,
					});
				} else {
					d.childIndex = index;

					if (source.childRelationshipTypes[index] ===
						CubiqTS.OrderRelationshipType.ON_TIMEOUT) {
						expiryIndex++;
					}

					let pathElement = {
						type: type,
						index: index,
						orderRelationshipType: source.childRelationshipTypes[index],
						expiryIndex: expiryIndex,
						rootId: d.visitorPath[0].rootId,
						sourceId: source.id,
						targetId: d.id,
					};
					d.visitorPath.push(pathElement);
				}
				return { source: source, target: d };
			} else {
				// track for tree
				d.visitorPath = [{
					type: 'ROOT',
					orderRelationshipType: CubiqTS.OrderRelationshipType.NONE,
					expiryIndex: 0,
					rootId: d.id,
					sourceId: d.id,
					targetId: d.id,
				}];
			}

			return null;
		};

		function traverseChildOrders(this: void, childRelationships: CubiqTS.Relationship[], nextX, nextY, oX, oY) {
			let maxNextX = nextX;
			let i = 0;

			while (i < childRelationships.length) {
				let currentOrder = childRelationships[i].order;
				let currentNextX =
					traverseOrder(currentOrder, new StrategyData(), maxNextX, nextY, oX, oY, i);
				maxNextX = Math.max(maxNextX, currentNextX);

		 		if (currentOrder.siblingRelationship == Object(currentOrder.siblingRelationship) &&
					CubiqTS.OrderRelationshipType.OCO == currentOrder.siblingRelationship.relationshipType) {
					// skip second OCO child in model.
					i++;
				}

				i++;
			}

			return maxNextX;
		};

		function traverseSiblingOrder(this: void, order: CubiqTS.OrderDataImpl, d: StrategyData, x, y, oX, oY) {
			handleOrder(order, d, x, y, oX, oY);

			let nextX = x + 1;
			let nextY = y + 1;

			// check if sibling has any children
			if (Array.isArray(order.childRelationships) &&
				order.childRelationships.length > 0) {
				let currentNextX = traverseChildOrders(order.childRelationships, x, nextY, x, y);

				nextX = Math.max(nextX, currentNextX);
			} else {
				// edge detected
				visitorPaths.push(d.visitorPath);
			}

			return nextX;
		};

		function traverseOrder(this: void, order: CubiqTS.OrderDataImpl, d: StrategyData, x, y, oX?, oY?, childIndex?) {

			handleOrder(order, d, x, y, oX, oY, childIndex);

			let nextX = x + 1;
			let nextY = y + 1;

			if (Array.isArray(order.childRelationships) &&
				order.childRelationships.length > 0) {
				nextX = traverseChildOrders(order.childRelationships, x, nextY, x, y);
			}

			let siblingRelationshipType = null;

			if (order.siblingRelationship === Object(order.siblingRelationship)) {
				nextX =
					traverseSiblingOrder(order.siblingRelationship.order, new StrategyData, nextX, y, x, y);
			}

			if ((d.childRelationshipTypes !== Object(d.childRelationshipTypes) ||
				d.childRelationshipTypes.length === 0) &&
				d.siblingRelationshipType === null) {
				// edge detected
				visitorPaths.push(d.visitorPath);
			}

			return nextX;
		};

		traverseOrder(rootOrder, new StrategyData(), 0, 0);

		let strategyData = new StrategyLayoutData(
			Array.from(orderMap.values()),
			childLinks,
			siblingLinks,
			visitorPaths,
			width,
			height,
			maxX,
			maxY
		);

		return strategyData;
	} */

  public render(inputData, svgTarget, selectedId, selectCallback) {
    let strategy = this;
    let orderWidth = this._configData.orderWidth;
    let orderHeight = this._configData.orderHeight;
    let linkWidth = this._configData.linkWidth;
    let linkHeight = this._configData.linkHeight;
    let linkPadding = this._configData.linkPadding;
    let data;
    let actionsService = this._oeActions;

    /* if (inputData instanceof CubiqTS.OrderDataImpl) {
			data = this.data(inputData);
			//data = this.scale(data);
			data = this.scale2(data);
		} else { // inputData is instance of

			data = this.scale2(inputData);
		} */
    data = this.scale2(inputData);
    /* if(inputData instanceof StrategyLayoutData){
			data = this.scale2(inputData);
		}else{
			logger.out.error("ERROR: BfxOrderEntryStrategyLayoutPlugin.render(): inputData is wrong format! inputData = ", inputData);
			return;
		} */
    //logger.out.info(`DEV_TEST OE render input data size: `, data.nodes.length, ' data dump:', data, ' | input data:', inputData);

    this._svg = _d3
      .select(svgTarget)
      .attr("width", this._configData.width ? this._configData.width : data.width)
      .attr("height", this._configData.height ? this._configData.height : data.height)
      .on("strategyDataUpdated", function () {
        try {
          if (_d3.event.detail == Object(_d3.event.detail)) {
            let id = _d3.event.detail.id;
            let label = _d3.event.detail.label;
            let e: Element = _d3.event.target;
            let strategyLegId = document.querySelector(`[data-target-id="${id}"]`);
            let textNode = [[e.ownerDocument.getElementById("strategy-node-label-id--" + id)]];
            // let textNode =  _d3.select(`#strategy-node-label-id--${id}`);
            let textContent1 = label ? label.substr(0, splitLabelTextAtIndex(label)) : "";
            let textContent2 = label ? label.substr(splitLabelTextAtIndex(label)) : "";

            if (textNode[0][0]) {
              textNode[0][0].children[0].textContent = textContent1;
              textNode[0][0].children[1].textContent = textContent2;
            }

            let invalid = actionsService.doesItHaveValidationErrors(id);

            if (strategyLegId && strategyLegId.matches(`[data-target-id="${id}"]`)) {
              if (!invalid) {
                strategyLegId.classList.remove("invalid");
              } else {
                strategyLegId.classList.add("invalid");
              }
            }
          }
        } catch (e) {
          logger.out.error("failed to apply strategyDataUpdated event detail to node e=", e);
          //	logger.out.error('failed to apply strategyDataUpdated event detail to node e=', e);
        }
      });

    this._svg.html("");

    let svg = this._svg.append("svg");

    function sendResizeEvent() {
      try {
        let event = new CustomEvent("resize", {
          detail: {
            width: data.width,
            height: data.height,
          },
        });

        svgTarget.dispatchEvent(event);
      } catch (ex) {
        //	logger.out.error('failed to send resize event to container! ex=', ex);
      }
    }
    sendResizeEvent();

    svg
      .attr("class", "strategy-layout")
      .attr("width", this._configData.width ? this._configData.width : data.width)
      .attr("height", this._configData.height ? this._configData.height : data.height);

    // filters go in defs element
    var defs = svg.append("defs");

    // create filter with id #drop-shadow
    // height=130% so that the shadow is not clipped
    var filter = defs.append("filter").attr("id", "drop-shadow").attr("height", "120%");

    // SourceAlpha refers to opacity of graphic that this filter will be applied to
    // convolve that with a Gaussian with standard deviation 3 and store result
    // in blur
    filter
      .append("feGaussianBlur")
      .attr("in", "SourceAlpha")
      .attr("stdDeviation", 2)
      .attr("result", "blur");

    // translate output of Gaussian blur to the right and downwards with 2px
    // store result in offsetBlur
    filter
      .append("feOffset")
      .attr("in", "blur")
      .attr("dx", 1)
      .attr("dy", 1)
      .attr("result", "offsetBlur");

    // overlay original SourceGraphic over translated blurred opacity by using
    // feMerge filter. Order of specifying inputs is important!
    let feMerge = filter.append("feMerge");

    feMerge.append("feMergeNode").attr("in", "offsetBlur");
    feMerge.append("feMergeNode").attr("in", "SourceGraphic");

    let group = svg.append("svg:g").attr("transform", "translate(" + 1 + "," + 20 + ")");

    let node = group
      .selectAll(".nodes")
      .data(data.nodes)
      .enter()
      .append("svg:g")
      .attr("class", "strategy-node")
      .attr("transform", function (d: StrategyData) {
        return "translate(" + d.x + "," + d.y + ")";
      });

    function renderSiblingLinkLeftmost(d: LinkedStrategyData) {
      return (
        "M" +
        (d.source.x + orderWidth * 0.95 + linkPadding) +
        "," +
        (d.source.y - orderHeight * 0.1) +
        "H" +
        (d.source.x + (d.target.x - d.source.x) / 2 - linkPadding + orderWidth * 0.3) +
        "V" +
        (d.target.y - orderHeight * 0.1)
      );
    }

    function renderSiblingLinkTypeX(d: LinkedStrategyData) {
      let orderWidthMultipler = 0.36;

      if (d.source.siblingRelationshipType === CubiqTS.OrderRelationshipType.LOOP) {
        orderWidthMultipler = 0.34;
      }

      return d.source.x + (d.target.x - d.source.x) / 2 + orderWidth * orderWidthMultipler;
    }

    function renderSiblingLinkTypeWidth(d: LinkedStrategyData) {
      return orderWidth * 0.2;
    }

    function renderSiblingLinkTypeY(d: LinkedStrategyData) {
      return d.target.y;
    }

    function renderSiblingLinkRightmost(d: LinkedStrategyData) {
      return (
        "M" +
        (d.source.x + (d.target.x - d.source.x) / 2 + linkPadding + orderWidth * 0.63) +
        "," +
        (d.source.y - orderHeight * 0.1) +
        "H" +
        (d.target.x - linkPadding) +
        "V" +
        (d.target.y - orderHeight * 0.1)
      );
    }

    function renderChildLinkTop(d: LinkedStrategyData) {
      if (d.target.childIndex === 0) {
        return (
          "M" +
          (d.source.x + orderWidth * 0.5) +
          "," +
          (d.source.y + orderHeight * 0.4 + linkPadding) +
          "V" +
          (d.source.y + orderHeight * 0.1 + linkHeight / 2 - linkPadding)
        );
      } else {
        // draw vertical line for each child
        let path: string =
          "M" +
          (d.target.x + orderWidth * 0.5) +
          "," +
          (d.source.y +
            orderHeight * 0.4 +
            (d.source.y + orderHeight * 0.1 + linkHeight / 2) +
            linkPadding) /
            2 +
          "V" +
          (d.source.y + linkHeight / 2 - linkPadding);

        if (d.target.childIndex === d.source.childRelationshipTypes.length - 1) {
          // additionally draw a horizontal line between source and last child
          path +=
            "M" +
            (d.source.x + orderWidth * 0.5) +
            "," +
            (d.source.y +
              orderHeight * 0.2 +
              (d.source.y + orderHeight * 0.1 + linkHeight / 2) +
              linkPadding) /
              2 +
            "H" +
            (d.target.x + orderWidth * 0.5);
        }

        return path;
      }
    }

    function renderChildLinkTypeX(d: LinkedStrategyData) {
      let orderWidthMultipler = 0.34;

      if (
        d.source.childRelationshipTypes[d.target.childIndex] ===
        CubiqTS.OrderRelationshipType.ON_TIMEOUT
      ) {
        orderWidthMultipler = 0.3;
      }

      return d.target.x + orderWidth * orderWidthMultipler;
    }

    function renderChildLinkTypeY(d: LinkedStrategyData) {
      return (d.source.y + d.target.y) * 0.495;
    }

    function renderChildLinkBottom(d: LinkedStrategyData) {
      return (
        "M" +
        (d.target.x + orderWidth * 0.5) +
        "," +
        ((d.source.y + orderHeight * 0.115 + d.target.y) / 2 + linkPadding) +
        "H" +
        (d.target.x + orderWidth * 0.5) +
        "V" +
        (d.target.y - orderHeight * 0.5 - linkPadding)
      );
    }

    function orderTypeText(t: CubiqTS.OrderRelationshipType) {
      switch (t) {
        case CubiqTS.OrderRelationshipType.GAMMA:
          return "Gamma";
        case CubiqTS.OrderRelationshipType.IFDONE:
          return "If Done";
        case CubiqTS.OrderRelationshipType.LOOP:
          return "Loop";

        case CubiqTS.OrderRelationshipType.OCO:
          return "OCO";
        case CubiqTS.OrderRelationshipType.ON_TIMEOUT:
          return "On Timeout";
        case CubiqTS.OrderRelationshipType.NONE:
        default:
          return "";
      }
    }

    group
      .selectAll(".child-link-top")
      .data(data.childLinks)
      .enter()
      .append("path")
      .attr("class", "child-link-top")
      .attr("d", renderChildLinkTop);

    group
      .selectAll(".child-link-label")
      .data(data.childLinks)
      .enter()
      .append("svg:text")
      .attr("class", "link-label")
      .attr("x", renderChildLinkTypeX)
      .attr("y", renderChildLinkTypeY)
      .text(function (d: LinkedStrategyData) {
        return orderTypeText(d.source.childRelationshipTypes[d.target.childIndex]);
      });

    group
      .selectAll(".child-link-bottom")
      .data(data.childLinks)
      .enter()
      .append("path")
      .attr("class", "child-link-bottom")
      .attr("d", renderChildLinkBottom);

    group
      .selectAll(".sibling-link-leftmost")
      .data(data.siblingLinks)
      .enter()
      .append("path")
      .attr("class", "sibling-link-leftmost")
      .attr("d", renderSiblingLinkLeftmost);

    group
      .selectAll(".sibling-link-label")
      .data(data.siblingLinks)
      .enter()
      .append("svg:text")
      .attr("class", "link-label")
      .attr("x", renderSiblingLinkTypeX)
      .attr("y", renderSiblingLinkTypeY)
      .attr("width", renderSiblingLinkTypeWidth)
      .text(function (d: LinkedStrategyData) {
        return orderTypeText(d.source.siblingRelationshipType);
      });

    group
      .selectAll(".sibling-link-rightmost")
      .data(data.siblingLinks)
      .enter()
      .append("path")
      .attr("class", "sibling-link-rightmost")
      .attr("d", renderSiblingLinkRightmost);

    let assignSelectionId = function (d: StrategyData /*, i, node*/) {
      let id = d.id;

      d.visitorPath.forEach(function (element) {
        id += "-" + element.type;

        if (element.index >= 0) {
          id += "-" + element.index;
        }
      });

      return id;
    }.bind(this);

    let selectionButtonNode = node
      .append("svg:g")
      .attr("class", function (d, i) {
        let invalid = actionsService.doesItHaveValidationErrors(d.id);

        if (selectedId === d.id || (!selectedId && i === 0)) {
          strategy._selectedId = selectedId;
          strategy._selectedNode = this;

          return invalid
            ? "strategy-node-selection-group selected invalid"
            : "strategy-node-selection-group selected";
        }

        return invalid ? "strategy-node-selection-group invalid" : "strategy-node-selection-group";
      })
      .on("click", function (d: StrategyData, i) {
        let selectedNode = this;

        if (strategy._configData.selectable && selectedNode != strategy._selectedNode) {
          let event = new CustomEvent("selection", {
            detail: {
              id: d.id,
              node: selectedNode,
              lastNode: strategy._selectedNode,
            },
          });

          let switchStrategyAllowed: boolean = actionsService.isSwitchStrategyAllowed(
            strategy._selectedId,
          );
          let dataValid =
            selectCallback != null
              ? selectCallback(strategy._selectedId)
              : actionsService.validateOrderDataAndNotify(strategy._selectedId);
          //logger.out.info(`INFO: _oeStrategyRender: Current node: ${strategy._selectedId} |  Valid: ${ dataValid ? 'YES': 'NO'}  | Allowed: ${switchStrategyAllowed ? 'YES': 'NO'} | Target node:  ${d.id}`);

          if (switchStrategyAllowed) {
            if (dataValid) {
              if (strategy._configData.selectableManaged) {
                strategy.selectStrategyNode(event);
              }
              svgTarget.dispatchEvent(event);
            } else {
              strategy.setStrategyNodeInvalid(event);
            }
          }
        }
      })
      .attr("data-root-id", function (d: StrategyData) {
        return d.visitorPath[0].rootId;
      })
      .attr("data-source-id", function (d: StrategyData) {
        return d.visitorPath[d.visitorPath.length - 1].sourceId;
      })
      .attr("data-target-id", function (d: StrategyData) {
        // return d.visitorPath[d.visitorPath.length - 1].targetId;
        return d.id;
      })
      .attr("data-order-relationship-type", function (d: StrategyData) {
        return d.visitorPath[d.visitorPath.length - 1].orderRelationshipType;
      })
      .attr("id", function (d: StrategyData, i) {
        // root walk for creationPermitted
        let selectedNode = _d3.select(this);

        return assignSelectionId(d, i, selectedNode); // Note binding
      });

    selectionButtonNode
      .append("svg:rect")
      .attr("class", "strategy-node-background")
      .attr("x", 0)
      .attr("y", (orderHeight / 2) * -1)
      .attr("width", orderWidth * 0.95)
      .attr("height", orderHeight * 0.7);
    // .style("filter", "url(#drop-shadow)");

    let selectionButtonTextNode = selectionButtonNode
      .append("svg:text")
      .attr("class", "strategy-node-label")
      .attr("id", function (d: StrategyData) {
        return `strategy-node-label-id--${d.id}`;
      })
      .attr("x", orderWidth * 0.5)
      .attr("y", 2)
      .style("text-anchor", "middle");

    selectionButtonTextNode
      .append("tspan")
      .text((d: StrategyData) => d.label.substr(0, splitLabelTextAtIndex(d.label.trim())));

    selectionButtonTextNode
      .append("tspan")
      .text((d: StrategyData) => d.label.substr(splitLabelTextAtIndex(d.label.trim())));

    if (this._configData.removable) {
      let removeButtonNode = selectionButtonNode
        .append("svg:g")
        .attr("class", function (d: StrategyData, i) {
          // allow css to hide root element /w node-remove-group-0
          return `strategy-node-remove-group strategy-node-remove-group-${i}`;
        })
        .style("display", function (d: StrategyData, i) {
          let removable = actionsService.isStrategyNodeRemovalAllowed(d.id);
          return removable ? "inherit" : "none";
        });
      removeButtonNode.on("click", (d: StrategyData, i) => {
        let event = new CustomEvent("remove", {
          detail: d,
        });

        svgTarget.dispatchEvent(event);
      });

      removeButtonNode
        .append("svg:circle")
        .attr("class", "remove-button-circle")
        .attr("cx", orderWidth - 24)
        .attr("cy", -2)
        .attr("r", 8)
        .attr("stroke-width", 0);
      removeButtonNode
        .append("svg:text")
        .attr("class", "remove-button-label")
        .attr("x", orderWidth - 28)
        .attr("y", 2)
        .text("x");
    }

    return this;
  }

  public config(x: StrategyLayoutConfigData) {
    if (!arguments.length) {
      return this._configData;
    }

    // take newly provided values
    this._configData = Object.assign({}, DEFAULT_CONFIG_DATA, x);

    return this;
  }

  public selectStrategyNode(event) {
    this._selectedId = event.detail.id;
    this._selectedNode = event.detail.node;

    // FXBFXOM-406
    if (NativeDesktopSupport.isNativeDesktopContainer() && this._selectedNode != null) {
      let wnd = NativeDesktopSupport.getWindow(this._selectedNode);
      if (wnd) {
        wnd.hideSmallWindows();
      }
    }

    let invalid = this._oeActions.doesItHaveValidationErrors(this._selectedId);

    if (!invalid) {
      event.detail.lastNode.classList.remove("invalid");
    }

    event.detail.lastNode.classList.remove("selected");
    event.detail.node.classList.add("selected");

    return this;
  }

  public setStrategyNodeInvalid(event) {
    //this._selectedId = event.detail.id;
    //this._selectedNode = event.detail.node;

    event.detail.lastNode.classList.add("invalid");
    //event.detail.node.classList.add('invalid');

    return this;
  }

  public node() {
    if (this._svg) {
      return this._svg.select("svg").node();
    }

    return null;
  }
}
